import { defineNuxtPlugin } from '#imports';

export default defineNuxtPlugin(() => ({
  provide: {
    logger: console,
  },
}));
